import ActionTypes from '../constants';

const initialState = {
    vehicleTypes: {},
    vehicleType: {}
    // loading: false,
};

const vehicleTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETVEHICLETYPESUCCESS:
            return {
                ...state,
                vehicleTypes: action.payload,
            }
        case ActionTypes.GETVEHICLETYPEBYIDSUCCESS:
            return {
                ...state,
                vehicleType: action.payload,
            }
        case ActionTypes.SAVEVEHICLETYPESUCCESS:
            // 
            return {
                ...state,
                vehicleType: action.payload,
            }
        default:
            return state;
    }
}

export default vehicleTypeReducer;